@if (!someAreUsed) {
  <div class="object-usage-field__object-unused">
    <mat-icon>
      check_circle
    </mat-icon>

    <span>
      {{ 'TRANS__OBJECT_USAGE__NONE_ARE_USED' | translate }}
    </span>
  </div>
}
@else {
  <div>
    @for (objectUsage of objectUsages; track $index) {
      <ng-container>
        @if (objectUsage.objectsUsing.length) {
          <ng-container>
            <button
              mat-stroked-button
              color="primary"
              type="button"
              class="object-usage-field__button"
              (click)="toggleShowUsage(objectUsage)"
              [ngClass]="{'active': objectUsage.showItems}"
            >
              <span class="object-usage-field__button-text bold">
                <span>
                  {{objectUsage.objectName}}
                </span>

                <span>
                  ({{objectUsage.objectsUsing.length}})
                </span>
              </span>

              <mat-icon>
                {{objectUsage.showItems ? 'expand_less' : 'expand_more'}}
              </mat-icon>
            </button>
          </ng-container>
        }
      </ng-container>
    }

    @if (lastShowUsage?.showItems) {
      <mat-chip-listbox class="object-usage-field__objects">
        @for (objectUsing of lastShowUsage.objectsUsing; track $index) {
          <mat-chip-option class="object-usage-field__object">
            {{objectUsing.artifact_name}}
          </mat-chip-option>
        }
      </mat-chip-listbox>
    }
  </div>
}
